import React, { useEffect, useState, Fragment, useRef, useCallback } from 'react';
import $ from 'jquery';
import jQuery from 'jquery';
import DataTable from 'datatables.net';
import Spinner from 'react-bootstrap/Spinner';
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';

import PropTypes from 'prop-types';

import { SRLWrapper } from 'simple-react-lightbox';

import { getApiUrl, getPantDocFromNivel, getDecodedCookie, getAhorayyyymmdd, btnsImportExportFile, importFileToBBDD } from '../../helpers/helperApp';


// JS
import 'datatables.net';              // DataTables core
import 'datatables.net-dt';           // DataTables base para estilo DT
import 'datatables.net-bs4';          // Integración con Bootstrap 4
import 'datatables.net-buttons';      // Buttons core
import 'datatables.net-buttons-bs4';  // Buttons para Bootstrap 4
import 'datatables.net-buttons/js/buttons.colVis.js';
import 'datatables.net-buttons/js/buttons.html5.js';
import 'datatables.net-buttons/js/buttons.print.js';
import 'datatables.net-select';       // Select (debe ir después de DataTables)
import 'datatables.net-rowreorder';
import 'datatables.net-rowgroup';
import 'datatables.net-responsive';   // Responsive core



let date = new Date();
let mesHoy = date.getMonth() + 1;
let h = date.getDate();
let hoy = (h < 10 ? h = '0'+h : h = h )+'/'+(mesHoy < 10 ? mesHoy = '0'+mesHoy : mesHoy = mesHoy )+'/'+date.getFullYear();


function MiDataTable(props){
    // Extraer props primero para evitar errores de inicialización
    const { id, data, columnas, formulario, selectId, selectIds, selectIdsKeySearch, lastSelectedId } = props;
    
    // Ref para persistir el último ID seleccionado durante la sesión
    const lastSelectedIdRef = useRef(lastSelectedId || null);
    
    // State para forzar re-render cuando se selecciona un registro
    const [highlightTrigger, setHighlightTrigger] = useState(0);
    
    // Sincronizar ref con prop externa si cambia
    useEffect(() => {
        if (lastSelectedId && lastSelectedIdRef.current !== lastSelectedId) {
            lastSelectedIdRef.current = lastSelectedId;
        }
    }, [lastSelectedId]);

    let { buttons, ordering, order, searching, paging, select, handleEditReg, handleDeleteItem, saveLoadingTable, loadingTable, estadoForm, columnactions, traduction, linkColumns, functionClickTd, pagelength, columnsFunctionClickTd, txtFilterTable, noDisplay, rowreorder, functionAfterReorder, functionAfterSelect, clickBtnDataTableButtons, importExportFile, fnReloadTable, idRegImportExport, paginationInfo, onSearchChange, searchBackend, exportExcelUrl, exportPdfUrl } = props;

    // Funciones para exportar usando endpoints del backend
    const handleExportExcel = () => {
        if (!exportExcelUrl) return;

        // Obtener término de búsqueda actual si existe
        let url = exportExcelUrl;
        if (searchBackend && $.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
            const oTable = $("." + id).DataTable();
            if (oTable) {
                const searchTerm = oTable.search();
                if (searchTerm) {
                    url += (url.includes('?') ? '&' : '?') + 'search=' + encodeURIComponent(searchTerm);
                }
            }
        }

        window.location.href = url;
    };

    const handleExportPdf = () => {
        if (!exportPdfUrl) return;

        // Obtener término de búsqueda actual si existe
        let url = exportPdfUrl;
        if (searchBackend && $.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
            const oTable = $("." + id).DataTable();
            if (oTable) {
                const searchTerm = oTable.search();
                if (searchTerm) {
                    url += (url.includes('?') ? '&' : '?') + 'search=' + encodeURIComponent(searchTerm);
                }
            }
        }

        window.open(url, '_blank');
    };

    var botones = [
        {
            extend: 'pageLength',
            text: `<i style='font-size: 20px;' class='fal fa-list-ol'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
            // titleAttr: 'Ver número de registros'
        },
        // {
        //     extend: 'copy',
        //     text: `<i style='font-size: 20px;' class='fal fa-copy'></i>`,
        //     className: 'btn btn-flat mr-1 btn-outline-secondary',
        //     // titleAttr: 'Copiar al portapapeles',
        //     exportOptions: {
        //         columns: ':visible'
        //     }
        // }, 
        // {
        //     extend: 'csv',
        //     filename: hoy,
        //     text: `<i style='font-size: 20px;' class='fal fa-file-csv'></i>`,
        //     className: 'btn btn-flat mr-1 btn-outline-secondary',
        //     title: hoy,
        //     // titleAttr: 'Exportar a csv',
        //     exportOptions: {
        //         columns: ':visible'
        //     }
    
        // },
        exportExcelUrl ? {
            text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
            action: handleExportExcel
        } : {
            extend: 'excel',
            filename: hoy,
            text: `<i style='font-size: 20px;' class='fal fa-file-excel'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
            title: hoy,
            // titleAttr: 'Exportar a excel',
            exportOptions: {
                columns: ':visible'
            }
        }, 
        exportPdfUrl ? {
            text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
            action: handleExportPdf
        } : {
            extend: 'pdf',
            filename: hoy,
            text: `<i style='font-size: 20px;' class='fal fa-file-pdf'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
            orientation: 'landscape', 
            title: hoy,
            // titleAttr: 'Exportar a pdf',
            exportOptions: {
                columns: ':visible'
            }
        }, 
        // {
        //     extend: 'print',
        //     filename: hoy,
        //     text: `<i style='font-size: 20px;' class='fal fa-print'></i>`,
        //     className: 'btn btn-flat mr-1 btn-outline-secondary',
        //     title: hoy,
        //     // titleAttr: 'Imprimir',
        //     customize: function ( win ) {
        //         $(win.document.body)
        //             .css( 'font-size', '22pt' );
    
        //         $(win.document.body).find( 'table' )
        //             .addClass( 'compact' )
        //             .css( 'font-size', '14pt' );
        //     },
        //     exportOptions: {
        //         modifier: {
        //             selected: null
        //         }
        //     },
        //     exportOptions: {
        //         columns: ':visible'
        //     }
        // },
        {
            extend: 'colvis',
            text: `<i style='font-size: 20px;' class='fad fa-line-columns'></i>`,
            className: 'btn btn-flat mr-1 btn-outline-secondary',
        }
    ];


    const cookies = new Cookies();

    const [noDisplayState, saveNoDisplayState] = useState(noDisplay);
    
    const fileInputRef = useRef(null);


    const existenBotones = (botones) => {    
        let data = false;
        botones.map(boton => {                    
            if(boton[0] != undefined){
                if(boton[0].className.includes('btnSeleccion')){
                    data = true;
                }
            }
        })
        return data;
    }

    // En las tablas que tengan activadas la selección le metemos las opciones de "Marcar todo", "Desmarcar Todo" e "Invertir selección"
    if( select !== undefined && select !== false ){
        if( select.style == "multi" ){
            if( !existenBotones(botones) ){
                const newBtns = [
                    {
                        extend: 'collection',
                        text: "<i style='font-size: 20px' class='fal fa-check'></i>",
                        className: 'btn btn-flat mr-1 btn-outline-secondary btnSeleccion',
                        buttons: [
                            {
                                // text: "<i style='font-size: 20px' class='fas fa-ballot-check'></i>",
                                text: "<i style='font-size: 20px' class='fal fa-check-square'></i>",
                                className: 'dt-button buttons-columnVisibility',
                                action: function ( e, dt, node, config ) {
                                    actionsBtnSelector( 0 );
                                }
                            },
                            {
                                // text: "<i style='font-size: 20px' class='fal fa-ballot-check'></i>",
                                text: "<i style='font-size: 20px' class='fal fa-square'></i>",
                                className: 'dt-button buttons-columnVisibility',
                                action: function ( e, dt, node, config ) {
                                    actionsBtnSelector( 1 );
                                }
                            },
                            {
                                // text: "<i style='font-size: 20px' class='fad fa-ballot-check'></i>",
                                text: "<i style='font-size: 20px' class='fas fa-check-square'></i>",
                                className: 'dt-button buttons-columnVisibility',
                                action: function ( e, dt, node, config ) {
                                    actionsBtnSelector( 2 );
                                }
                            }
                        ]
                    }
                ];
                botones.push(newBtns);
            }
        }
    }

    if(id == 'manlogv2pend'){          
        const newBtn = {
                        extend: 'collection',
                        text: "<i style='font-size: 20px' class='fal fa-history'></i>",
                        className: `btn btn-flat mr-1 btn-outline-secondary filterBtnManlogV2`,
                        action: function ( e, dt, node, config ) {                                    
                                    clickBtnDataTableButtons( true );
                        }                        
                       };        
        botones.push(newBtn);
    }
    
    useEffect(()=>{
        
        // Verificar que DataTable está disponible antes de procesar
        if (!$ || !$.fn || !$.fn.DataTable) {
            return;
        }

        const accionesMiDataTable = columnas.find(column => column["title"] === columnactions);

        // Si ya existe la columna de acciones la eliminamos ya que sino da error cuando seleccionas un reg, vas a otra pantalla, vuelves y seleccionas otro reg.        
        if( accionesMiDataTable !== undefined ){
            columnas.splice( (columnas.length-1), 1 );
        }
        // Añadimos los enlaces a los td
        if( linkColumns != undefined ){
            for( let i = 0; i < columnas.length; i++ ){
                columnas[i].createdCell = (td, cellData, rowData, row, col) => {

                    if( linkColumns[i] != undefined ){
                        // Aplicamos el estilo a las celdas añadiendo las clases recibidas en el sql en el key 'style'
                        if ('style' in rowData){
                            $(td).addClass(rowData["style"]);
                        }
                        //Creamos los enlaces
                        if( typeof cellData == "string" ){
                            if( cellData.toLowerCase() != "Media".toLowerCase()  && cellData != "Average".toLowerCase() && cellData.toLowerCase() != "Total".toLowerCase() ){
                                // Si el enlace es a la pantalla de documentos obtenemos la pantalla que le corresponde según su id
                                if( linkColumns[i].link == "/documentos" ){
                                    linkColumns[i].link = getPantDocFromNivel(getDecodedCookie('nivel'));
                                }

                                if( linkColumns[i].data.includes("/") && linkColumns[i].link != "" ){
                                    const links = linkColumns[i].data.split("/");
                                    $(td).html("<a href='"+window.location.origin+linkColumns[i].link+"/"+rowData[links[0]]+"/"+rowData[links[1]]+"' >"+cellData+"</a>");
                                }else if( linkColumns[i].link != "" ){
                                    $(td).html("<a href='"+window.location.origin+linkColumns[i].link+"/"+rowData[linkColumns[i].data]+"' >"+cellData+"</a>");
                                }
                            }
                        }
                    } 
                    // Si la celda contiene la cadena '/assets/' y rowData hay una key foto asumimos que es una foto
                    if( 'foto' in rowData || 'img' in rowData ){
                        if( cellData ){
                            if( cellData.includes('/assets/')  ){
                                $(td).html("<img src='"+getApiUrl(window.location.origin)+cellData+"' style='width: 50px !important; cursor: pointer;' />");
                            }
                        }else{
                            $(td).html("<span></span>");
                        }
                    }                   
                    if( functionClickTd ){
                        if( columnsFunctionClickTd ){
                            if( columnsFunctionClickTd.includes(col) ){
                                $(td).on('click', function (e) {
                                    e.preventDefault();
                                    functionClickTd(e, rowData);
                                });
                            }
                        }else{
                            $(td).on('click', function (e) {
                                e.preventDefault();
                                functionClickTd(e, rowData);
                            });
                        }                        
                    }

                    // Modificaciones para la tabla de la pantalla kpis
                    if( id == "kpis" ){
                        if( typeof cellData == "string" && rowData.idcentro != -1 ){
                            if( cellData.toLowerCase().includes("Media".toLowerCase())  || cellData.toLowerCase().includes("Average".toLowerCase()) || cellData.toLowerCase().includes("Total".toLowerCase()) ){
                                $(td).addClass("tdAvg");
                                $(td).parent('tr').addClass("trAvg");
                            }
                        }
                        if( typeof cellData == "string" && rowData.idcentro == -1 ){
                            $(td).addClass("tdTotal");
                            $(td).parent('tr').addClass("trTotal");
                        }
                        if( col > 0 ){
                            $(td).addClass("text-right");
                        }
                        // % Correctivos
                        if( col == 4 ){
                            $(td)[0].innerText = $(td)[0].innerText+" %";

                            if( cellData < 5 ){
                                $(td).addClass("alert-success");
                            }
                            if( cellData >= 5 && cellData <= 10 ){
                                $(td).addClass("alert-warning");
                            }
                            if( cellData > 10 ){
                                $(td).addClass("alert-danger");
                            }
                        }
                        // Costes
                        if( col == 6 || col == 7 ){
                            if( cellData > 0 ){
                                $(td).addClass("alert-success");
                            }
                            if( cellData == 0 ){
                                $(td).addClass("alert-warning");
                            }
                            if( cellData < 0 ){
                                $(td).addClass("alert-danger");
                            }
                            $(td)[0].innerText = $(td)[0].innerText+" €";
                        }
                    }
                    // Modificaciones para la pantalla stockart
                    if( id == "stockart" ){
                        if( typeof cellData == "string" && rowData.id_ubicacion == -1 ){
                            $(td).addClass("tdTotal");
                            $(td).parent('tr').addClass("trTotal");
                        }
                        if( col > 1 ){
                            $(td).addClass("text-right");
                            
                            if( rowData.stock_min > 0 ){
                                if( parseInt(rowData.unidades) <= 0 ){
                                    $(td).addClass("alert-danger");
                                }
                                if( parseInt(rowData.unidades) > parseInt(rowData.stock_min) ){
                                    $(td).addClass("alert-success");
                                }
                                if( parseInt(rowData.unidades) <= parseInt(rowData.stock_min) ){
                                    $(td).addClass("alert-warning");
                                }
                            }else{
                                if( parseInt(rowData.unidades) <= 0 ){
                                    $(td).addClass("alert-danger");
                                }
                                if( parseInt(rowData.unidades) > 0 ){
                                    $(td).addClass("alert-success");
                                }
                            }
                        }
                    }
                }
            }
        }else{
            for( let i = 0; i < columnas.length; i++ ){
  
                columnas[i].createdCell = (td, cellData, rowData, row, col) => {
                        // Aplicamos el estilo a las celdas añadiendo las clases recibidas en el sql en el key 'style'                        
                        if ('style' in rowData){
                            $(td).addClass(rowData["style"]);
                        }
                        // Si la celda contiene la cadena '/assets/' y rowData hay una key foto asumimos que es una foto
                        if( 'foto' in rowData || 'img' in rowData ){
                            if( cellData ){
                                if( cellData.includes('/assets/')  ){

                                    let templateFoto = `
                                    <div>                                   
                                            <div class="containerImgTablePending">
                                                <img class="imgUplmTablePending" src=${getApiUrl(window.location.origin)+cellData} />
                                            </div>                                                                                                                                        
                                    </div>
                                    `;
                                    $(td).html(templateFoto);
                                    // $(td).html("<img src='"+getApiUrl(window.location.origin)+cellData+"' style='width: 100px !important; cursor: pointer' />");
                                }
                            }else{
                                $(td).html("<span></span>");
                            }
                        }
                        if( functionClickTd ){
                            if( columnsFunctionClickTd ){
                                if( columnsFunctionClickTd.includes(col) ){
                                    $(td).on('click', function (e) {
                                        e.preventDefault();
                                        functionClickTd(e, rowData);
                                    });
                                }
                            }else{
                                $(td).on('click', function (e) {
                                    e.preventDefault();
                                    functionClickTd(e, rowData);
                                });
                            }                        
                        }
                    // Modificaciones para la tabla de la pantalla kpis
                    if( id == "kpis" ){
                        if( typeof cellData == "string" && rowData.idcentro != -1 ){
                            if( cellData.toLowerCase().includes("Media".toLowerCase())  || cellData.toLowerCase().includes("Average".toLowerCase()) || cellData.toLowerCase().includes("Total".toLowerCase()) ){
                                $(td).addClass("tdAvg");
                                $(td).parent('tr').addClass("trAvg");
                            }
                        }
                        if( typeof cellData == "string" && rowData.idcentro == -1 ){
                            $(td).addClass("tdTotal");
                            $(td).parent('tr').addClass("trTotal");
                        }
                        if( col > 0 ){
                            $(td).addClass("text-right");
                        }
                        // % Correctivos
                        if( col == 4 ){
                            $(td)[0].innerText = $(td)[0].innerText+" %";

                            if( cellData < 5 ){
                                $(td).addClass("alert-success");
                            }
                            if( cellData >= 5 && cellData <= 10 ){
                                $(td).addClass("alert-warning");
                            }
                            if( cellData > 10 ){
                                $(td).addClass("alert-danger");
                            }
                        }
                        // Costes
                        if( col == 6 || col == 7 ){
                            if( cellData > 0 ){
                                $(td).addClass("alert-success");
                            }
                            if( cellData == 0 ){
                                $(td).addClass("alert-warning");
                            }
                            if( cellData < 0 ){
                                $(td).addClass("alert-danger");
                            }
                            $(td)[0].innerText = $(td)[0].innerText+" €";
                        }
                    }  
                    // Modificaciones para la pantalla stockart
                    if( id == "stockart" ){
                        if( typeof cellData == "string" && rowData.id_ubicacion == -1 ){
                            $(td).addClass("tdTotal");
                            $(td).parent('tr').addClass("trTotal");
                        }
                        if( col > 0 ){
                            $(td).addClass("text-right");
                        }
                    }
                }
            }
        }
    
        if( columnactions != null && columnactions != "null" && columnactions != "" ){
            columnas.push({      
                title: columnactions,
                data: null,
                className: 'text-center',
                sortable: false,
                createdCell : (td, cellData, rowData, row, col) => { 

                                let templateBtn =  ReactDOM.render(<div className="flex-center">
                                                            <span 
                                                                id={ rowData.id } 
                                                                className=" btn btn-flat btn-outline-primary mr-1"
                                                                style={{border: 0}} 
                                                                onClick={ e => { lastSelectedIdRef.current = rowData.id; setHighlightTrigger(prev => prev + 1); handleEditReg(e) }} >
                                                                    <i 
                                                                        className="fal fa-edit" 
                                                                        id={ rowData.id } 
                                                                        onClick={ e => { lastSelectedIdRef.current = rowData.id; setHighlightTrigger(prev => prev + 1); handleEditReg(e) }} 
                                                                    >                                                    
                                                                    </i>
                                                            </span>
                                                            {
                                                                estadoForm !== "disabled" && estadoForm !== "readonly"
                                                                ?
                                                                    <span 
                                                                        id={ rowData.id } 
                                                                        data-idpadre={ rowData.iddoc ? rowData.iddoc : rowData.idcic ? rowData.idcic : null } 
                                                                        className="btn btn-flat btn-outline-danger deleteRow" 
                                                                        style={{border: 0}}
                                                                        onClick={ e => { handleDeleteItem(e) } }>
                                                                            <i  
                                                                                    id={ rowData.id }
                                                                                    data-idpadre={ rowData.iddoc ? rowData.iddoc : rowData.idcic ? rowData.idcic : null } 
                                                                                    className="fal fa-trash-alt deleteRow"
                                                                                    onClick={ e => { handleDeleteItem(e) }}
                                                                                >
                                                                            </i>
                                                                    </span>
                                                                :
                                                                null
                                                            }
                                                        </div>
                                                    ,td);
                                $(td).html(templateBtn)
                }
            });
        }

        buttons === undefined || buttons === true || buttons === "true" ? buttons = 'Bfrtip' : buttons = 'frtip';
        ordering === undefined ? ordering = true : ordering = ordering;
        order === undefined ? order = [[0,"asc"]] : order = order;
        searching === undefined ? searching = true : searching = searching;
        paging === undefined ? paging = true : paging = paging;
        pagelength === undefined ? pagelength = traduction.defaultpagelength : pagelength = pagelength;
        select === undefined ? select = false : select = select;
        
        
        columnas.map((columna, i) => {
            
            if( i == 2 && (id == "manlogv2his" || id == "manloghis")){
                // Acciones
                columna.createdCell = (td, cellData, rowData, row, col) => {                     
                    let templateNecesario;                   
                    if(parseInt(rowData.numadj) > 0){
                        templateNecesario =  ReactDOM.render(
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}} onClick={e => functionClickTd(e, rowData)}>
                                <i className="far fa-paperclip mr-1" ></i>
                            </div>
                        ,td);
                    }else{                        
                        templateNecesario =  ReactDOM.render(
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}} onClick={e => functionClickTd(e, rowData)}>
                            </div>                                                       
                        ,td); 
                    }
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario)                                        
                }                    
            }
            if( i == 5 && id == "lineaslogboook"){                                
                columna.createdCell = (td, cellData, rowData, row, col) => {                     
                    let templateNecesario;                   
                    if(parseInt(rowData.numadj) > 0){
                        templateNecesario =  ReactDOM.render(
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}} onClick={e => functionClickTd(e, rowData)}>
                                <i className="far fa-paperclip mr-1" ></i>
                            </div>
                        ,td);
                    }else{                        
                        templateNecesario =  ReactDOM.render(
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}} onClick={e => functionClickTd(e, rowData)}>
                            </div>                                                       
                        ,td); 
                    }
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario)                                        
                }                    
            }
            if( i == 6 && id == "lineaslogboook"){                                
                columna.createdCell = (td, cellData, rowData, row, col) => {                     
                    let templateNecesario;                   
                    if(parseInt(rowData.numfir) > 0){
                        templateNecesario =  ReactDOM.render(
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}} onClick={e => functionClickTd(e, rowData)}>
                                <i className="fal fa-file-signature mr-1" ></i>
                            </div>
                        ,td);
                    }else{                        
                        templateNecesario =  ReactDOM.render(
                            <div style={{display: "flex", justifyContent: "center", alignItems: "center"}} onClick={e => functionClickTd(e, rowData)}>
                            </div>                                                       
                        ,td); 
                    }
                    $(td).addClass(rowData.style);
                    $(td).html(templateNecesario)                                        
                }                    
            }
            if(id == "manlogv2pend"){
                const ahora = getAhorayyyymmdd();
                columna.createdCell = (td, cellData, rowData, row, col) => {
                    let templateNecesario =  ReactDOM.render(
                        <div onClick={e => functionClickTd(e, rowData)}>
                            <span dangerouslySetInnerHTML={{__html: cellData}}></span>
                        </div>
                    ,td);       
                    if(rowData.exp_date <= ahora && (rowData.noleido === false || rowData.noleido === 'false')){
                        $(td).addClass('text-bold text-danger');
                    }else if(rowData.noleido === false || rowData.noleido === 'false'){
                        $(td).addClass('text-bold');
                    }
                    $(td).html(templateNecesario)                                                                
                    
                }  
            }            
        })
        
        
        if( importExportFile == true){
            botones = [...botones];
            botones = btnsImportExportFile(saveLoadingTable, traduction, fileInputRef, botones, id, data, idRegImportExport);
        }                

        if( data ){
            if( data.length > 0 ){
                if ( $.fn.DataTable.isDataTable("."+id) ) {
                    let oTable;
                    try {
                        oTable = $("."+id).DataTable();
                    } catch (e) {
                        return;
                    }
                    
                    if (!oTable || !oTable.clear || !oTable.rows || !oTable.rows.add) {
                        return;
                    }

                    oTable.clear();
                    oTable.rows.add(data);
                    
                    // Si es búsqueda backend, asegurar que no haya filtro local
                    if (searchBackend) {
                        oTable.search('');
                    }
                    
                    oTable.draw(false);
                }else{
                    $("."+id).DataTable({
                        mark: true,
                        rowId: function(a) {
                            return '#row-' + a.id;},
                        dom: buttons,
                        data: data,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        search: searchBackend ? { search: "", smart: false } : undefined,
                        paging: paging,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false, 
                        autoWidth: false,
                        retrieve: true,
                        pageLength: parseInt(pagelength),
                        lengthMenu: [
                            [ 10, 25, 50, 100 ],
                            [ '10', '25', '50', '100' ]
                        ],
                        rowReorder: rowreorder ? true : false,
                        deferRender: true,
                        language: {
                            "sProcessing":    traduction.sprocessing.title,
                            "sLengthMenu":    traduction.slengthmenu.title,
                            "sZeroRecords":   traduction.szerorecords.title,
                            "sEmptyTable":    traduction.semptytable.title,
                            "sInfo":          paginationInfo || traduction.sinfo.title,
                            "sInfoEmpty":     traduction.sinfoempty.title,
                            "sInfoFiltered":  traduction.sinfofiltered.title,
                            "sInfoPostFix":   traduction.sinfopostfix.title,
                            "sSearch":        traduction.ssearch.title,
                            "sUrl":           traduction.surl.title,
                            "sInfoThousands":  traduction.sinfothousands.title,
                            "sLoadingRecords": traduction.sloadingrecords.title,
                            "oPaginate": {
                                "sFirst":    traduction.sfirst.title,
                                "sLast":    traduction.slast.title,
                                "sNext":    traduction.snext.title,
                                "sPrevious": traduction.sprevious.title
                            },
                            "oAria": {
                                "sSortAscending":  traduction.ssortascending.title,
                                "sSortDescending": traduction.ssortdescending.title
                            },
                            select: {
                                rows: traduction.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.copytitle.title,
                                copyKeys: traduction.copykeys.title,
                                copySuccess: {
                                    _: traduction.copysuccess.many.title,
                                    1: traduction.copysuccess.one.title
                                },
                            }        
                        },
                        rowCallback : function (row, data, index){ 
                            // Si td campo incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                            for (let item of row.children) {
                                if( item.outerText.includes("#") ){
                                    item.bgColor = item.outerText;
                                    item.innerText = "";
                                }
                            }
                        }
                    })
                }  
                // saveLoadingTable(false);       
            }else{
                if ( $.fn.DataTable.isDataTable("."+id) ) {
                    let oTable = $("."+id).DataTable();
                    oTable.clear();
                    oTable.draw();               
                }{               
                    $("."+id).DataTable({
                        mark: true,
                        rowId: function(a) {
                            return '#row-' + a.id;},
                        dom: buttons,
                        data: null,
                        columns: columnas,
                        ordering: ordering,
                        order: order,
                        searching: searching,
                        search: searchBackend ? { search: "", smart: false } : undefined,
                        paging: paging,
                        select: select,
                        buttons: [botones],
                        // fixedHeader: true,
                        // scrollX: true,
                        responsive: false, 
                        autoWidth: false,
                        retrieve: true,
                        pageLength: parseInt(pagelength),
                        lengthMenu: [
                            [ 10, 25, 50, 100 ],
                            [ '10', '25', '50', '100' ]
                        ],
                        rowReorder: rowreorder ? true : false,
                        deferRender: true,
                        language: {
                            "sProcessing":    traduction.sprocessing.title,
                            "sLengthMenu":    traduction.slengthmenu.title,
                            "sZeroRecords":   traduction.szerorecords.title,
                            "sEmptyTable":    traduction.semptytable.title,
                            "sInfo":          paginationInfo || traduction.sinfo.title,
                            "sInfoEmpty":     traduction.sinfoempty.title,
                            "sInfoFiltered":  traduction.sinfofiltered.title,
                            "sInfoPostFix":   traduction.sinfopostfix.title,
                            "sSearch":        traduction.ssearch.title,
                            "sUrl":           traduction.surl.title,
                            "sInfoThousands":  traduction.sinfothousands.title,
                            "sLoadingRecords": traduction.sloadingrecords.title,
                            "oPaginate": {
                                "sFirst":    traduction.sfirst.title,
                                "sLast":    traduction.slast.title,
                                "sNext":    traduction.snext.title,
                                "sPrevious": traduction.sprevious.title
                            },
                            "oAria": {
                                "sSortAscending":  traduction.ssortascending.title,
                                "sSortDescending": traduction.ssortdescending.title
                            },
                            select: {
                                rows: traduction.rows.title
                            },
                            buttons: {
                                copyTitle: traduction.copytitle.title,
                                copyKeys: traduction.copykeys.title,
                                copySuccess: {
                                    _: traduction.copysuccess.many.title,
                                    1: traduction.copysuccess.one.title
                                },
                            }         
                        },
                        rowCallback : function (row, data, index){
                            // Si td campo incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                            for (let item of row.children) {
                                if( item.outerText.includes("#") ){
                                    item.bgColor = item.outerText;
                                    item.innerText = "";
                                }
                            }


                        }
                    })
                }
                // saveLoadingTable(false);
            }
        }else{
            if ( $.fn.DataTable.isDataTable("."+id) ) {
                let oTable;
                try {
                    oTable = $("."+id).DataTable();
                } catch (e) {
                    return;
                }

                if (!oTable || !oTable.clear || !oTable.draw) {
                    return;
                }

                oTable.clear();
                oTable.draw();               
            }{               
                $("."+id).DataTable({
                    mark: true,
                    rowId: function(a) {
                        return '#row-' + a.id;},
                    dom: buttons,
                    data: null,
                    columns: columnas,
                    ordering: ordering,
                    order: order,
                    searching: searching,
                    search: searchBackend ? { search: "", smart: false } : undefined,
                    paging: paging,
                    select: select,
                    buttons: [botones],
                    // fixedHeader: true,
                    // scrollX: true,
                    responsive: false, 
                    autoWidth: false,
                    retrieve: true,
                    pageLength: parseInt(pagelength),
                    lengthMenu: [
                        [ 10, 25, 50, 100 ],
                        [ '10', '25', '50', '100' ]
                    ],
                        rowReorder: rowreorder ? true : false,
                        deferRender: true,
                        language: {
                            "sProcessing":    traduction.sprocessing.title,
                            "sLengthMenu":    traduction.slengthmenu.title,
                            "sZeroRecords":   traduction.szerorecords.title,
                            "sEmptyTable":    traduction.semptytable.title,
                            "sInfo":          paginationInfo || traduction.sinfo.title,
                            "sInfoEmpty":     traduction.sinfoempty.title,
                            "sInfoFiltered":  traduction.sinfofiltered.title,
                            "sInfoPostFix":   traduction.sinfopostfix.title,
                            "sSearch":        traduction.ssearch.title,
                            "sUrl":           traduction.surl.title,
                            "sInfoThousands":  traduction.sinfothousands.title,
                            "sLoadingRecords": traduction.sloadingrecords.title,
                            "oPaginate": {
                                "sFirst":    traduction.sfirst.title,
                                "sLast":    traduction.slast.title,
                                "sNext":    traduction.snext.title,
                                "sPrevious": traduction.sprevious.title
                            },
                        "oAria": {
                            "sSortAscending":  traduction.ssortascending.title,
                            "sSortDescending": traduction.ssortdescending.title
                        },
                        select: {
                            rows: traduction.rows.title
                        },
                        buttons: {
                            copyTitle: traduction.copytitle.title,
                            copyKeys: traduction.copykeys.title,
                            copySuccess: {
                                _: traduction.copysuccess.many.title,
                                1: traduction.copysuccess.one.title
                            },
                        }       
                    },
                    rowCallback : function (row, data, index){
                        // Si algún td incluye un # asumimos que es un color con lo que se lo ponemos de fondo
                        for (let item of row.children) {
                            if( item.outerText.includes("#") ){
                                item.bgColor = item.outerText;
                                item.innerText = "";
                            }
                        }                        
                    }
                })
            }
            // saveLoadingTable(false);            
        }

        if( saveLoadingTable ){
            saveLoadingTable(false); 
        }

        // Código para llamar a una función tras reordenar las filas
        if( functionAfterReorder != null  ){
            if ($.fn.DataTable && $.fn.DataTable.isDataTable("."+id)) {
                let tabla;
                try {
                    tabla = $('#'+id).DataTable();
                } catch (e) {
                    // Silenciar error
                }
                
                if (tabla && tabla.on) {
                    tabla.on( 'row-reorder', function ( e, diff, edit ) {
                        functionAfterReorder( e, diff, edit);         
                    } );
                }
            }
        }

        // Código para llamar a una función tras seleccionar una fila
        if( functionAfterSelect != null  ){
            if ($.fn.DataTable && $.fn.DataTable.isDataTable("."+id)) {
                let tabla;
                try {
                    tabla = $('#'+id).DataTable();
                } catch (e) {
                    // Silenciar error
                }
                
                if (tabla && tabla.off && tabla.on) {
                    // Eliminar cualquier listener existente para evitar duplicados
                    tabla.off('click', 'tr');
                    
                    tabla.on( 'click', 'tr', function ( e, dt, type, indexes ) {                
                        if(e.currentTarget && e.currentTarget.id != ""){
                            setTimeout(() => {
                                if ($.fn.DataTable && $.fn.DataTable.isDataTable("."+id)) {
                                    let idRow = tabla.row( this ).id();         
                                    const datos = $('#'+id).DataTable().rows().data();
                                    const selectedRows = $('#'+id).DataTable().rows( { selected: true } ).data();
                                    functionAfterSelect(idRow, id, datos, selectedRows);                                                
                                }
                            }, 500);
                        }
                    } );
                }
            }
        }
        
    }, [data, formulario.id, selectIds])    

    // Funcion que realiza las acciones de los botones de Marcar todos, Desmarcar todos e Invertir Selección
    function actionsBtnSelector ( boton ) {
        if (!$.fn.DataTable.isDataTable("."+id)) {
            return;
        }

        let oTable;
        try {
            oTable = $("."+id).DataTable();
        } catch (e) {
            return;
        }

        if (!oTable || !oTable.rows) {
            return;
        }

        switch(boton){
            case 0:
                // Marcar todos
                oTable.rows({ search: 'applied' }).select();
                break;
            case 1:
                // Desmarcar todos
                oTable.rows({ search: 'applied' }).deselect();
                break;
            case 2:
                // Invertir selección
                var rows = oTable.rows( { selected: true, search: 'applied' } )[0];  
                oTable.rows({ search: 'applied' }).select();
                oTable.rows(rows).deselect();
                break;
        }
    }
    

    // Código para evitar los acentos en las búsquedas
    function removeAccents ( data ) {
        if ( data.normalize ) {
            // Use I18n API if avaiable to split characters and accents, then remove
            // the accents wholesale. Note that we use the original data as well as
            // the new to allow for searching of either form.
            return data +' '+ data
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '');
        }
     
        return data;
    }
    var searchType = jQuery.fn.DataTable.ext.type.search;
 
    searchType.string = function ( data ) {
        return ! data ?
            '' :
            typeof data === 'string' ?
                removeAccents( data ) :
                data;
    };
    
    searchType.html = function ( data ) {    
        return ! data ?
            '' :
            typeof data === 'string' ?
                removeAccents( data.replace( /<.*?>/g, '' ) ) :
                data;
    };
    // FIN: Código para evitar los acentos en las búsquedas 

    // Función para resaltar una fila por su ID
    const highlightRowById = useCallback((idToHighlight) => {
        if (!idToHighlight) {
            return;
        }

        try {
            // Quitar highlight anterior
            $('tr.selectedRow').removeClass('selectedRow');

            // Método 1: Buscar directamente por rowId (#row-{id}) - O(1)
            let $row = $(`#row-${idToHighlight}`);
            
            // Método 2: Si no existe, buscar en la tabla actual iterando - O(n)
            if (!$row.length && $.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
                const oTable = $("." + id).DataTable();
                if (oTable && oTable.rows && oTable.rows().data) {
                    const currentPageData = oTable.rows({ page: 'current' }).data();
                    for (let i = 0; i < currentPageData.length; i++) {
                        const rowId = currentPageData[i]?.id;
                        if (rowId !== undefined && String(rowId) === String(idToHighlight)) {
                            $row = $(oTable.table().node()).find('tbody tr').eq(i);
                            break;
                        }
                    }
                }
            }

            if ($row.length) {
                $row.addClass('selectedRow');
            }
        } catch (e) {
            // Silenciar errores
        }
    }, [id]);

    // Resaltar el row cuando se selecciona un registro o cuando cambia el formulario
    useEffect(() => {
        // Prioridad: 1) highlightTrigger (clic del usuario), 2) formulario.id
        const idToHighlight = highlightTrigger > 0 ? lastSelectedIdRef.current : formulario?.id || lastSelectedIdRef.current;
        
        if (!idToHighlight) {
            return;
        }

        // Delay para asegurar que la tabla/formulario está listo
        const timeoutId = setTimeout(() => {
            highlightRowById(idToHighlight);
        }, 300);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [highlightTrigger, formulario?.id, id]);

    // Seleccionar un id de la tabla - selectIds
    useEffect(() => {
        if (!selectIds || !selectIds.length || !$.fn.DataTable || !$.fn.DataTable.isDataTable("." + id)) {
            return;
        }

        try {
            let table = $("#"+id).DataTable();
            if (!table || !table.rows || !table.rows().data) {
                return;
            }
            let rows = table.rows().data();
            let last = null;        
            let indexes = table.rows().indexes();           
            for(let i=0; i < rows.length; i++){
                if( selectIds.includes(rows[i][selectIdsKeySearch]) ){                        
                    let globalIndex = indexes[i];
                    table.row(globalIndex).select();
                    last = {id: rows[i][selectIdsKeySearch]};
                }
            }
        } catch (e) {
            // Silenciar error
        }
    }, [selectIds, selectIdsKeySearch, id]);

    // Seleccionar un id de la tabla - selectId
    useEffect(() => {
        if (!selectId || !selectId.id || !$.fn.DataTable || !$.fn.DataTable.isDataTable("." + id)) {
            return;
        }

        try {
            const oTable = $("." + id).DataTable();
            if (oTable && oTable.rows && oTable.rows().data && oTable.rows().data().length > 0) {
                // Highlight logic handled by the main formulario useEffect
            }
        } catch (e) {
            // Silenciar error
        }

        // Adjuntar eventos solo una vez
        const tableElement = document.querySelector("." + id);
        if (tableElement && !tableElement.dataset.eventsAttached2) {
            if ($.fn.DataTable && $.fn.DataTable.isDataTable("." + id)) {
                try {
                    const oTable = $("." + id).DataTable();
                    if (oTable) {
                        oTable.on('page.dt', function () {
                            // Reaplicar highlight después de cambiar de página con mayor delay
                            setTimeout(() => {
                                if (lastSelectedIdRef.current) {
                                    highlightRowById(lastSelectedIdRef.current);
                                }
                            }, 500); // Aumentar delay para asegurar que la página se renderice completamente
                        });

                        oTable.on('length.dt', function () {
                            // Reaplicar highlight después de cambiar el tamaño de página
                            setTimeout(() => {
                                if (lastSelectedIdRef.current) {
                                    highlightRowById(lastSelectedIdRef.current);
                                }
                            }, 200);
                        });
                        tableElement.dataset.eventsAttached2 = "true";
                    }
                } catch (e) {
                    // Silenciar error
                }
            }
        }
    }, [selectId, id]);

    // Actualizar info de la tabla cuando cambia la paginación del backend
    useEffect(() => {
        if (paginationInfo && $.fn.DataTable.isDataTable("." + id)) {
            let oTable = $("." + id).DataTable();
            if (oTable) {
                oTable.settings()[0].oLanguage.sInfo = paginationInfo;
                oTable.draw(false);
            }
        }
    }, [paginationInfo, id]);

    // Manejar búsqueda del servidor
    useEffect(() => {
        if (!onSearchChange || !$.fn.DataTable || !$.fn.DataTable.isDataTable("." + id)) {
            return;
        }

        let oTable;
        try {
            oTable = $("." + id).DataTable();
        } catch (e) {
            return;
        }
        
        let searchTimeout = null;

        const handleSearch = (e, settings) => {
            // Limpiar timeout anterior
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }

            // Debounce para evitar múltiples llamadas rápidas
            searchTimeout = setTimeout(() => {
                const searchValue = settings.oPreviousSearch.sSearch;
                // Solo buscar si hay un valor o si es la primera carga
                if (searchValue !== undefined) {
                    onSearchChange(searchValue);
                }
            }, 500);
        };

        oTable.on('search.dt', handleSearch);

        return () => {
            if (searchTimeout) {
                clearTimeout(searchTimeout);
            }
            try {
                oTable.off('search.dt', handleSearch);
            } catch (e) {
                // Silenciar error al desmontar
            }
        };
    }, [onSearchChange, id]);



    // Filtramos en la tabla un texto recibido como parámetros
    if( txtFilterTable != null && txtFilterTable != "" ){
        let tabla = $('#'+id).DataTable();
        tabla.search(txtFilterTable).draw();
    }


    return(
        <Fragment>
            {   loadingTable ? 
                    <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                        <Spinner animation="border" />
                    </div>
                :
                null
            }
            <div className={noDisplayState ? "noDisplay" : ""} style={{overflowX: "auto"}}>
                <table id={id} className={id+" table table-sm table-bordered table-striped table-hover dataTable "} 
                    style={{
                        width:"100%",
                        cursor: functionClickTd ? "pointer" : "default"
                    }} 
                >
                </table>
                {/* Input de archivo oculto para la importación de archivos */}
                <input
                    id="importFileToBBDD"
                    type="file"
                    ref={fileInputRef}
                    style={{ display: 'none' }}
                    accept=".xls,.xlsx"
                    onChange={ e => importFileToBBDD(saveLoadingTable, traduction, id, fnReloadTable, idRegImportExport)}
                />
            </div>   
            
        </Fragment>
    )
}

// MiDataTable.propTypes = {
//     id: PropTypes.string.isRequired,
//     data: PropTypes.array,
//     columnas: PropTypes.array,
//     formulario: PropTypes.object,
//     loading: PropTypes.bool,
//     selectId: PropTypes.object,
//     selectIds: PropTypes.array,
//     selectIdsKeySearch: PropTypes.string,
//     lastSelectedId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//     loadingTable: PropTypes.bool,
//     saveLoadingTable: PropTypes.func,
//     handleEditReg: PropTypes.func,
//     handleDeleteItem: PropTypes.func,
//     columnactions: PropTypes.string,
//     traduction: PropTypes.object,
//     linkColumns: PropTypes.array,
//     functionClickTd: PropTypes.func,
//     columnsFunctionClickTd: PropTypes.array,
//     pagelength: PropTypes.string,
//     noDisplay: PropTypes.bool,
//     txtFilterTable: PropTypes.string,
//     importExportFile: PropTypes.bool,
//     fnReloadTable: PropTypes.func,
//     idRegImportExport: PropTypes.number
// };

export default MiDataTable;